(function () {
  "use strict";

  if (window.__SPARC_CUSTOMER_LEATHER_ACK_V5__) return;
  window.__SPARC_CUSTOMER_LEATHER_ACK_V5__ = true;

  var CONFIGS = [
    {
      panel: "sparc-muscle-configurator",
      leather: "sparc-muscle-leather-color"
    },
    {
      panel: "sparc-driver-configurator",
      leather: "sparc-driver-leather-color"
    },
    {
      panel: "sparc-heritage-configurator",
      leather: "sparc-heritage-leather-color"
    },
    {
      panel: "sparc-classic-squarebody-configurator",
      leather: "sparc-classic-squarebody-leather-color"
    },
    {
      panel: "sparc-muscle-round-configurator",
      leather: "sparc-muscle-leather-color"
    },
    {
      panel: "sparc-classic-3100-configurator",
      leather: "sparc-classic-3100-leather-color"
    }

  ];

  var CUSTOMER_VALUE =
    "Customer Supplied";

  var PROPERTY_NAME =
    "_Customer Supplied Leather Lead Time Acknowledged";

  var acknowledged = false;

  /*
    The acknowledgement happens BEFORE
    Customer Supplied is actually selected.

    After acknowledgement, exactly one
    Customer Supplied card click is allowed
    through to the normal configurator.
  */
  var allowCustomerSelectionOnce =
    false;

  var pendingCustomerCard =
    null;

  var modal =
    null;

  var checkbox =
    null;

  var continueButton =
    null;

  var instructionPanel =
    null;

  /* ============================================================
     UTILITIES
     ============================================================ */

  function clean(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalize(value) {
    return clean(value)
      .replace(
        /[\u2018\u2019]/g,
        "'"
      )
      .replace(
        /[\u201C\u201D]/g,
        '"'
      )
      .toLowerCase();
  }

  function isCustomerValue(
    value
  ) {
    return (
      normalize(value)
        .indexOf(
          normalize(
            CUSTOMER_VALUE
          )
        ) !== -1
    );
  }

  function currentConfig() {
    for (
      var i = 0;
      i < CONFIGS.length;
      i++
    ) {
      if (
        document.getElementById(
          CONFIGS[i].panel
        )
      ) {
        return CONFIGS[i];
      }
    }

    return null;
  }

  function configurator() {
    var config =
      currentConfig();

    return config
      ? document.getElementById(
          config.panel
        )
      : null;
  }

  function leatherRoot() {
    var config =
      currentConfig();

    if (!config) return null;

    return document.getElementById(
      config.leather
    );
  }

  /* ============================================================
     LEATHER CARD DETECTION
     ============================================================ */

  function leatherCardFromEventTarget(
    target
  ) {
    if (
      !target ||
      typeof target.closest !==
        "function"
    ) {
      return null;
    }

    var config =
      currentConfig();

    var panel =
      configurator();

    if (
      !config ||
      !panel
    ) {
      return null;
    }

    var card =
      target.closest(
        '[data-source-id="' +
          config.leather +
          '"][data-value]'
      );

    if (
      card &&
      panel.contains(card)
    ) {
      return card;
    }

    return null;
  }

  function cardValue(
    card
  ) {
    if (!card) return "";

    return clean(
      card.dataset.value ||
      card.textContent
    );
  }

  function selectedLeatherCard() {
    var config =
      currentConfig();

    var panel =
      configurator();

    if (
      !config ||
      !panel
    ) {
      return null;
    }

    return panel.querySelector(
      '[data-source-id="' +
        config.leather +
        '"].is-selected'
    );
  }

  function selectedLeatherValue() {
    var card =
      selectedLeatherCard();

    if (card) {
      return cardValue(card);
    }

    return sourceLeatherValue();
  }

  /* ============================================================
     HULK SOURCE VALUE
     ============================================================ */

  function sourceLeatherValue() {
    var root =
      leatherRoot();

    if (!root) return "";

    var select =
      root.tagName === "SELECT"
        ? root
        : root.querySelector(
            "select"
          );

    if (select) {
      var option =
        select.options[
          select.selectedIndex
        ];

      if (!option) return "";

      var value =
        clean(
          option.textContent ||
          option.value
        );

      if (
        !value ||
        /^choose\b/i.test(
          value
        )
      ) {
        return "";
      }

      return value;
    }

    var checked =
      root.querySelector(
        'input[type="radio"]:checked,' +
        'input[type="checkbox"]:checked'
      );

    if (checked) {
      var value =
        clean(
          checked.value ||
          checked.getAttribute(
            "data-value"
          )
        );

      if (value) {
        return value;
      }

      if (checked.id) {
        var label =
          document.querySelector(
            'label[for="' +
              checked.id +
              '"]'
          );

        if (label) {
          return clean(
            label.textContent
          );
        }
      }
    }

    return "";
  }

  function customerSuppliedSelected() {
    return isCustomerValue(
      selectedLeatherValue()
    );
  }

  /* ============================================================
     PRODUCT FORM / ORDER PROPERTY
     ============================================================ */

  function productForm() {
    var panel =
      configurator();

    return (
      (panel &&
        panel.closest("form")) ||

      document.querySelector(
        '#ProductSection form[action*="/cart/add"]'
      ) ||

      document.querySelector(
        'form[action*="/cart/add"]'
      )
    );
  }

  function ensurePropertyInput() {
    var form =
      productForm();

    if (!form) return null;

    var input =
      form.querySelector(
        "[data-sparc-customer-leather-ack]"
      );

    if (!input) {
      input =
        document.createElement(
          "input"
        );

      input.type =
        "hidden";

      input.name =
        "properties[" +
        PROPERTY_NAME +
        "]";

      input.setAttribute(
        "data-sparc-customer-leather-ack",
        "true"
      );

      form.appendChild(
        input
      );
    }

    return input;
  }

  function syncProperty() {
    var input =
      ensurePropertyInput();

    if (!input) return;

    if (
      customerSuppliedSelected() &&
      acknowledged
    ) {
      input.disabled =
        false;

      input.value =
        "Yes";
    } else {
      input.value =
        "";

      input.disabled =
        true;
    }
  }

  function resetAcknowledgement() {
    acknowledged =
      false;

    syncProperty();

    var panel =
      configurator();

    if (panel) {
      panel.removeAttribute(
        "data-customer-leather-acknowledged"
      );
    }

    syncInstructionPanel();
  }

  /* ============================================================
     PERSISTENT SHIPPING INSTRUCTIONS
     ============================================================ */

  function ensureInstructionPanel() {
  var panel =
    configurator();

  if (!panel) return null;

  /*
    The instructions are intentionally OUTSIDE
    every accordion section.

    They sit directly after the complete accordion
    list so changing from Leather to Horn, Mounting,
    Accessories, Summary, etc. can never hide them.
  */
  var accordionList =
    panel.querySelector(
      ".sparc-accordion-list"
    );

  if (!accordionList) {
    return null;
  }

  var host =
    accordionList.parentElement ||
    panel;

  /*
    If the panel already exists, make sure it is
    in the correct persistent location.
  */
  if (
    instructionPanel &&
    document.body.contains(
      instructionPanel
    )
  ) {
    if (
      instructionPanel.previousElementSibling !==
      accordionList
    ) {
      host.insertBefore(
        instructionPanel,
        accordionList.nextSibling
      );
    }

    return instructionPanel;
  }

  /*
    Also recover an existing panel if the shared
    script was reloaded.
  */
  instructionPanel =
    panel.querySelector(
      "[data-sparc-customer-leather-instructions]"
    );

  if (instructionPanel) {
    host.insertBefore(
      instructionPanel,
      accordionList.nextSibling
    );

    return instructionPanel;
  }

  instructionPanel =
    document.createElement(
      "aside"
    );

  instructionPanel.className =
    "sparc-customer-leather-instructions";

  instructionPanel.setAttribute(
    "data-sparc-customer-leather-instructions",
    "true"
  );

  instructionPanel.hidden =
    true;

  instructionPanel.innerHTML =
    '<div class="sparc-customer-leather-instructions__eyebrow">' +
      'CUSTOMER-SUPPLIED LEATHER' +
    '</div>' +

    '<h3>' +
      'Material & Shipping Instructions' +
    '</h3>' +

    '<p class="sparc-customer-leather-instructions__intro">' +
      'Your production lead time begins after SPARC receives your leather.' +
    '</p>' +

    '<div class="sparc-customer-leather-instructions__grid">' +

      '<div class="sparc-customer-leather-instructions__item">' +

        '<span class="sparc-customer-leather-instructions__label">' +
          'MINIMUM MATERIAL SIZE' +
        '</span>' +

        '<strong>20&quot; × 24&quot;</strong>' +

        '<span>' +
          'Please send a piece no smaller than this size.' +
        '</span>' +

      '</div>' +

      '<div class="sparc-customer-leather-instructions__item">' +

        '<span class="sparc-customer-leather-instructions__label">' +
          'SHIP TO' +
        '</span>' +

        '<strong>SPARC Industries</strong>' +

        '<span>2072 Brandon Dr.</span>' +

        '<span>Tyler, Texas 75703</span>' +

      '</div>' +

    '</div>' +

    '<div class="sparc-customer-leather-instructions__order">' +

      '<span class="sparc-customer-leather-instructions__label">' +
        'INCLUDE WITH YOUR SHIPMENT' +
      '</span>' +

      '<p>' +
        'Place a note inside the package with your ' +
        '<strong>SPARC order number</strong> and the ' +
        '<strong>name used on the order</strong> so we can correctly match your leather to your steering wheel.' +
      '</p>' +

      '<p class="sparc-customer-leather-instructions__note">' +
        'Do not ship your leather until your order has been placed. ' +
        'Your order number will be provided after checkout.' +
      '</p>' +

    '</div>';

  /*
    Place it AFTER Configuration Summary / accordion list,
    not inside Leather.
  */
  host.insertBefore(
    instructionPanel,
    accordionList.nextSibling
  );

  return instructionPanel;
}

  function syncInstructionPanel() {
    var node =
      ensureInstructionPanel();

    if (!node) return;

    var show =
      acknowledged &&
      customerSuppliedSelected();

    node.hidden =
      !show;

    node.classList.toggle(
      "is-visible",
      show
    );
  }

  /* ============================================================
     MODAL
     ============================================================ */

  function ensureModal() {
    if (modal) return modal;

    modal =
      document.createElement(
        "div"
      );

    modal.className =
      "sparc-leather-ack-modal";

    modal.hidden =
      true;

    modal.innerHTML =
      '<div class="sparc-leather-ack-modal__backdrop"></div>' +

      '<section ' +
        'class="sparc-leather-ack-modal__dialog" ' +
        'role="dialog" ' +
        'aria-modal="true" ' +
        'aria-labelledby="sparc-leather-ack-title">' +

        '<button ' +
          'type="button" ' +
          'class="sparc-leather-ack-modal__close" ' +
          'aria-label="Close">' +
          '×' +
        '</button>' +

        '<div class="sparc-leather-ack-modal__eyebrow">' +
          'LEAD TIME ACKNOWLEDGEMENT' +
        '</div>' +

        '<h2 id="sparc-leather-ack-title">' +
          'Customer-Supplied Leather' +
        '</h2>' +

        '<p class="sparc-leather-ack-modal__message">' +
          'Your estimated production lead time begins after SPARC receives your customer-supplied leather.' +
        '</p>' +

        '<p class="sparc-leather-ack-modal__detail">' +
          'Shipping and transit time to SPARC is not included in the production estimate shown on this page. ' +
          'After acknowledgement, material size and shipping instructions will remain available in the Leather section.' +
        '</p>' +

        '<label class="sparc-leather-ack-modal__check">' +

          '<input type="checkbox">' +

          '<span>' +
            'I understand that my quoted production lead time does not begin until SPARC receives my leather.' +
          '</span>' +

        '</label>' +

        '<div class="sparc-leather-ack-modal__actions">' +

          '<button ' +
            'type="button" ' +
            'class="sparc-leather-ack-modal__back">' +
            'GO BACK' +
          '</button>' +

          '<button ' +
            'type="button" ' +
            'class="sparc-leather-ack-modal__continue" ' +
            'disabled>' +
            'ACKNOWLEDGE &amp; CONTINUE' +
          '</button>' +

        '</div>' +

      '</section>';

    document.body.appendChild(
      modal
    );

    checkbox =
      modal.querySelector(
        '.sparc-leather-ack-modal__check input'
      );

    continueButton =
      modal.querySelector(
        '.sparc-leather-ack-modal__continue'
      );

    checkbox.addEventListener(
      "change",
      function () {
        continueButton.disabled =
          !checkbox.checked;
      }
    );

    continueButton.addEventListener(
      "click",
      function () {
        if (
          !checkbox.checked
        ) {
          return;
        }

        acknowledged =
          true;

        var card =
          pendingCustomerCard;

        pendingCustomerCard =
          null;

        closeModal();

        if (card) {
          allowCustomerSelectionOnce =
            true;

          card.click();

          setTimeout(
            function () {
              allowCustomerSelectionOnce =
                false;

              syncProperty();
              syncInstructionPanel();

              var panel =
                configurator();

              if (
                panel &&
                customerSuppliedSelected()
              ) {
                panel.setAttribute(
                  "data-customer-leather-acknowledged",
                  "true"
                );
              }
            },
            160
          );
        }
      }
    );

    function cancelPendingSelection() {
      pendingCustomerCard =
        null;

      acknowledged =
        false;

      syncProperty();
      syncInstructionPanel();
      closeModal();
    }

    modal
      .querySelector(
        ".sparc-leather-ack-modal__close"
      )
      .addEventListener(
        "click",
        cancelPendingSelection
      );

    modal
      .querySelector(
        ".sparc-leather-ack-modal__back"
      )
      .addEventListener(
        "click",
        cancelPendingSelection
      );

    modal
      .querySelector(
        ".sparc-leather-ack-modal__backdrop"
      )
      .addEventListener(
        "click",
        cancelPendingSelection
      );

    document.addEventListener(
      "keydown",
      function (event) {
        if (
          event.key === "Escape" &&
          modal &&
          !modal.hidden
        ) {
          cancelPendingSelection();
        }
      }
    );

    return modal;
  }

  function openModal() {
    var node =
      ensureModal();

    checkbox.checked =
      false;

    continueButton.disabled =
      true;

    node.hidden =
      false;

    node.classList.add(
      "is-open"
    );

    document.documentElement
      .classList.add(
        "sparc-leather-ack-open"
      );

    setTimeout(
      function () {
        checkbox.focus();
      },
      20
    );
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove(
      "is-open"
    );

    modal.hidden =
      true;

    document.documentElement
      .classList.remove(
        "sparc-leather-ack-open"
      );
  }

  /* ============================================================
     CUSTOMER SUPPLIED CLICK INTERCEPTOR
     ============================================================ */

  document.addEventListener(
    "click",
    function (event) {
      if (
        !event.target ||
        typeof event.target.closest !==
          "function"
      ) {
        return;
      }

      var leatherCard =
        leatherCardFromEventTarget(
          event.target
        );

      if (leatherCard) {
        var value =
          cardValue(
            leatherCard
          );

        /*
          Black, Brown, etc.
        */
        if (
          !isCustomerValue(
            value
          )
        ) {
          if (
            acknowledged ||
            customerSuppliedSelected()
          ) {
            resetAcknowledgement();
          }

          return;
        }

        /*
          Customer Supplied is already
          acknowledged and selected.
        */
        if (
          acknowledged &&
          customerSuppliedSelected()
        ) {
          return;
        }

        /*
          This is the one approved
          programmatic click after
          acknowledgement.
        */
        if (
          allowCustomerSelectionOnce
        ) {
          allowCustomerSelectionOnce =
            false;

          return;
        }

        /*
          Stop the selection BEFORE
          the normal configurator handler
          can select Customer Supplied.
        */
        event.preventDefault();

        event.stopPropagation();

        if (
          typeof event
            .stopImmediatePropagation ===
          "function"
        ) {
          event.stopImmediatePropagation();
        }

        pendingCustomerCard =
          leatherCard;

        acknowledged =
          false;

        syncProperty();
        syncInstructionPanel();

        openModal();

        return;
      }

      /* ========================================================
         ADD TO CART GUARD
         ======================================================== */

      var form =
        productForm();

      if (!form) return;

      var addButton =
        event.target.closest(
          '[name="add"],' +
          'button[type="submit"],' +
          'input[type="submit"]'
        );

      if (
        addButton &&
        form.contains(
          addButton
        ) &&
        customerSuppliedSelected() &&
        !acknowledged
      ) {
        event.preventDefault();

        event.stopPropagation();

        if (
          typeof event
            .stopImmediatePropagation ===
          "function"
        ) {
          event.stopImmediatePropagation();
        }

        openModal();
      }
    },

    true
  );

  /* ============================================================
     FORM SUBMIT GUARD
     ============================================================ */

  document.addEventListener(
    "submit",
    function (event) {
      var form =
        productForm();

      if (
        !form ||
        event.target !== form
      ) {
        return;
      }

      if (
        customerSuppliedSelected() &&
        !acknowledged
      ) {
        event.preventDefault();

        event.stopPropagation();

        if (
          typeof event
            .stopImmediatePropagation ===
          "function"
        ) {
          event.stopImmediatePropagation();
        }

        openModal();
      } else {
        syncProperty();
      }
    },
    true
  );

  /* ============================================================
     SOURCE CHANGE SAFETY
     ============================================================ */

  document.addEventListener(
    "change",
    function () {
      setTimeout(
        function () {
          if (
            !customerSuppliedSelected()
          ) {
            if (acknowledged) {
              resetAcknowledgement();
            }
          }

          syncProperty();
          syncInstructionPanel();
        },
        100
      );
    },
    true
  );

  /* ============================================================
     STARTUP
     ============================================================ */

  function start() {
    if (!configurator()) {
      setTimeout(
        start,
        300
      );

      return;
    }

    acknowledged =
      false;

    ensureInstructionPanel();
    syncProperty();
    syncInstructionPanel();

    console.info(
      "[SPARC ACK V5] Customer-supplied leather acknowledgement and shipping instructions active."
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();